import './FormLayout.css'
import RequiredMark from '../form/RequiredMark'

function FormLayout({ title, actions, children, onSubmit, requiredLegend }) {
    const Tag = onSubmit ? 'form' : 'div'

    return (
        <Tag className="fl-wrapper" onSubmit={onSubmit}>
            <div className="fl-header">
                {title && (
                    <div className="fl-title-block">
                        <p className="fl-title">{title}</p>
                        <span className="fl-title-accent" />
                        {requiredLegend && <span className="fl-required-legend"><RequiredMark /> Campo obrigatório</span>}
                    </div>
                )}
                {actions && (
                    <div className="fl-actions">{actions}</div>
                )}
            </div>
            <div className="fl-body">
                {children}
            </div>
        </Tag>
    )
}

export default FormLayout
